import axios from 'axios'
import { ServiceRouter } from '../../../../../base/proxy/serviceRouter'
import { getToken, getUserId } from '../../../../../base/proxy/helper'

/**
 * Banner videosunu (mp4, en fazla 200 MB) base64 JSON yerine multipart/form-data olarak yükler.
 * Base64 JSON yolunda tek bir değer ~166 milyon karakterle sınırlı olduğu için (~125 MB dosya) büyük
 * video "The JSON value of length ... is too large" ile düşüyordu. Dönen dosya adı banner'ın
 * Image / MobilImage alanına yazılır (PostVideoLargeApi deseni).
 */
export class UploadBannerVideoApi {
  public async upload(file: File): Promise<string> {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${ServiceRouter.getServiceUrl()}admin/banner/upload-file`, form, {
      timeout: 30 * 60 * 1000,
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
      headers: {
        Authorization: `Bearer ${getToken()}`,
        UserId: String(getUserId()),
        // Content-Type bilerek verilmez: multipart sınırını axios kendisi ekler
      },
    })

    const data = response.data
    const fileName = data?.Data?.FileName
    if (!data?.Success || !fileName) {
      throw { code: data?.Code, description: data?.Message || 'Video yüklenemedi.', success: false }
    }
    return fileName
  }
}
